export { InputBS } from './inputbs.component';
export { InputBSModule } from './inputbs.module';
